import { Box } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";
import React from "react";

import DropdownField from "../../../../../common/form/dropdown/DropdownField";
import AgeSelection from "./AgeSelection";

import { gender } from "../../../../../../constants/optionList/gender";
import { districts } from "../../../../../../constants/patient";
import FormStepTitle from "../../../../../common/form/Steps/FormStepTitle";
import PatientAdmissionTitleAndInput from "../../../../patient/AddPatient/form/PatientAdmissionTitleAndInput";
import { GenderSelectBtn, H5 } from "../../../../patient/styles";

const AdmissionDetails = () => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const districtInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value, true);
    if (e.target.name === "district") {
      const selectedDistrictName: any = districts.find(
        (item: string) => item === e.target.value
      );
      if (selectedDistrictName) {
        setFieldValue(
          "DISTRICT_NAME",
          selectedDistrictName.substr(0, 3)?.toUpperCase()
        );
      }
    }
  };

  return (
    <>
      <FormStepTitle title="Admission Details" required={false} />

      <PatientAdmissionTitleAndInput
        title="Patient Name*"
        name="name"
        placeholder="Patient Name"
        disabled
      />

      <PatientAdmissionTitleAndInput
        title="Parent Name*"
        name="parentsName"
        placeholder="Parent Name*"
        disabled
      />

      <AgeSelection />

      <H5>Gender*</H5>
      {Object.entries(gender).map(([key, value]) => (
        <GenderSelectBtn
          key={key}
          type="button"
          selected={values?.sex === value?.value}
          onClick={() => setFieldValue("sex", value?.value)}
          disabled
        >
          {value?.label}
        </GenderSelectBtn>
      ))}

      <Box>
        <Box>
          <H5>District Information*</H5>
          <DropdownField
            name="district"
            label="District Information"
            dropDownList={districts.map((d) => ({ _id: d, name: d }))}
            itemFieldValue="_id"
            itemFieldLabel="name"
            value={values?.district}
            disabled
            onChange={districtInputHandler}
            sx={{
              "& .MuiInputBase-root": {
                backgroundColor: "#dcdcdc",
                borderRadius: "4px",
              },
            }}
          />
        </Box>
      </Box>

      <PatientAdmissionTitleAndInput
        title="Block*"
        name="village"
        placeholder="Block"
        disabled
      />

      <PatientAdmissionTitleAndInput
        title="Village/Town/Area*"
        name="address"
        placeholder="Village/Town/Area"
        disabled
      />
      {/* 
      <PatientAdmissionTitleAndInput
        title="Patient Address*"
        name="address"
        placeholder="Patient Address"
      /> */}

      <PatientAdmissionTitleAndInput
        title="Contact Phone*"
        name="phone"
        placeholder="Patient Phone"
        disabled
      />

      <PatientAdmissionTitleAndInput
        title="Email"
        name="email"
        type="email"
        placeholder="Patient Email"
        disabled
      />
    </>
  );
};

export default AdmissionDetails;
